import { useWhatsAppNumbers } from '../../settings/hooks/useSettings';
import type { WhatsAppNumber } from '../../settings/services/settingsService';
import { Conversation } from '../../../types';

/** The store's numbers when it has more than one; [] otherwise, so a
 *  single-number store renders no number UI at all. */
export function useMultipleWhatsAppNumbers(): WhatsAppNumber[] {
  const { data } = useWhatsAppNumbers();
  return data && data.length > 1 ? data : [];
}

/** Which business number a conversation is on: its own, else the default. */
export function numberForConversation(
  conversation: Conversation,
  numbers: WhatsAppNumber[]
): WhatsAppNumber | undefined {
  if (conversation.whatsappNumberId) {
    return numbers.find((n) => n.id === conversation.whatsappNumberId);
  }
  if (conversation.channel === 'web') return undefined;
  return numbers.find((n) => n.isDefault);
}
